module.exports = __webpack_public_path__ + "img/icon-column.ccdfac18.svg";